import styled from 'styled-components';
import { Button as ButtonAntD } from 'antd';

export const Wrapper = styled.div`
  margin: 0 auto;
`;

export const Blank = styled.div`
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.21);
  margin: 0 24px;
  padding: 32px;
  width: 1090px;
`;

export const Button = styled(ButtonAntD)`
  border-radius: 3px;

  &.ant-btn-primary {
    background-color: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }

  &.ant-btn:not(.ant-btn-primary) {
    &:hover,
    &:focus,
    &:active {
      border-color: ${({ theme }) => theme.primary};
      color: ${({ theme }) => theme.primary};
    }
  }
`;

export const Listing = styled.div`
  margin-top: 24px;
`;
